import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import axios from 'axios';

// Configure axios to send credentials (cookies) with every request
axios.defaults.withCredentials = true;

// Suppress known development warnings and errors
if (process.env.NODE_ENV === 'development') {
  const originalError = console.error;
  const originalWarn = console.warn;
  const originalLog = console.log;
  
  console.error = (...args) => {
    const msg = args[0]?.toString() || '';
    if (
      msg.includes('r.stripe.com') || 
      msg.includes('Permissions-Policy') ||
      msg.includes('ERR_BLOCKED_BY_CLIENT') ||
      msg.includes('browsing-topics') ||
      msg.includes('run-ad-auction') ||
      msg.includes('private-state-token') ||
      msg.includes('private-aggregation') ||
      msg.includes('attribution-reporting') ||
      msg.includes('join-ad-interest-group') ||
      msg.includes('FetchError') ||
      msg.includes('Failed to fetch') ||
      msg.includes('Cross-Origin-Opener-Policy') ||
      msg.includes('accounts.google.com/gsi')
    ) {
      return;
    }
    originalError(...args);
  };

  console.warn = (...args) => {
    const msg = args[0]?.toString() || '';
    if (
      msg.includes('Permissions-Policy') ||
      msg.includes('Origin trial') ||
      msg.includes('Cross-Origin-Opener-Policy') ||
      msg.includes('[Stripe.js]')
    ) {
      return;
    }
    originalWarn(...args);
  };

  console.log = (...args) => {
    const msg = args[0]?.toString() || '';
    if (
      msg.includes('>=116') // Stripe version log
    ) {
      return;
    }
    originalLog(...args);
  };

  // Swallow known Stripe/ad-block related unhandled promise rejections
  window.addEventListener('unhandledrejection', (event) => {
    try {
      const reason = event?.reason;
      const msg =
        (reason && (reason.message || (reason.toString && reason.toString()))) ||
        '';
      if (
        typeof msg === 'string' &&
        (
          msg.includes('https://r.stripe.com/b') ||
          msg.includes('r.stripe.com/b') ||
          msg.includes('FetchError') ||
          msg.includes('ERR_BLOCKED_BY_CLIENT')
        )
      ) {
        event.preventDefault();
        return;
      }
    } catch (e) {
      // ignore any issues in the handler itself
    }
  });
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <App />
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    if (process.env.NODE_ENV === 'production') {
      navigator.serviceWorker
        .register('/service-worker.js')
        .catch((error) => {
          // eslint-disable-next-line no-console
          console.error('Service worker registration failed:', error);
        });
      return;
    }

    // In development, a registered service worker can cache old bundles and make
    // UI changes appear to "not update". Ensure it is unregistered.
    navigator.serviceWorker
      .getRegistrations()
      .then((regs) => Promise.all(regs.map((r) => r.unregister())))
      .catch(() => {});
  });
}
